import { type ColumnType, type Selectable } from 'kysely'
import { z } from 'zod'

import { cableId, type CableId } from './Cable.js'
import {
  sensorCalibrationId,
  type SensorCalibrationId,
} from './SensorCalibration.js'

/** Represents the view public.sensor_calibration_orphaned_view_ */
export default interface SensorCalibrationOrphanedViewTable {
  /** Database type: pg_catalog.uuid */
  id: ColumnType<SensorCalibrationId, never, never>

  /** Database type: pg_catalog.text */
  sensorId: ColumnType<string, never, never>

  /** Database type: pg_catalog.int4 */
  cableId: ColumnType<CableId, never, never>

  /** Database type: pg_catalog.int4 */
  sensorNumber: ColumnType<number, never, never>

  /** Database type: pg_catalog.int4 */
  cableSerial: ColumnType<number | null, never, never>
}

export type SensorCalibrationOrphanedView =
  Selectable<SensorCalibrationOrphanedViewTable>

export const sensorCalibrationOrphanedView = z.object({
  id: sensorCalibrationId,
  sensorId: z.string(),
  cableId: cableId,
  sensorNumber: z.number(),
  cableSerial: z.number().nullable().optional(),
}) as unknown as z.Schema<SensorCalibrationOrphanedView>
